// extracted by mini-css-extract-plugin
module.exports = {"MediaRowCard":"nmuoL","MediaRowCard__Figure":"_7Y0Oj","MediaRowCard__Figure_active":"zwqMf","MediaRowSlide":"G2jzy","MediaRowSlide__Inner":"xXaSa"};